import { RequestConfig, RequestConfigType } from '@client/common/utils/api/RequestConfig';

export class Restock {
  public static subscribe(
    email: string,
    sku: number,
  ): RequestConfigType {
    return RequestConfig.post(
      'products/restock-subscribe',
      {
        email,
        sku,
      },
    );
  }
}
